/* eslint-disable no-underscore-dangle */
export var getSFDDLValue = function (value) {
    var _a, _b, _c;
    return (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window._SFDDL) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b[value]) !== null && _c !== void 0 ? _c : undefined;
};
//# sourceMappingURL=helpers.js.map